import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { RebelColors, RebelLabel, RebelInput, RebelSelect } from "../../../styles/rebel-experiences";
import { currencyOptions } from "../../../utils/budget-tool-specific";

const RebelBudgetConfig = ({ config, onChange, tripLength }) => {
    return (
        <ConfigContainer>
            <Row>
                <Col lg="4" md="6">
                    <FormGroup>
                        <RebelLabel>Company / Group Name</RebelLabel>
                        <RebelInput
                            type="text"
                            value={config.companyName}
                            onChange={e => onChange("companyName", e.target.value)}
                            placeholder="Enter company name"
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="3">
                    <FormGroup>
                        <RebelLabel>Attendees</RebelLabel>
                        <RebelInput
                            type="number"
                            min="1"
                            value={config.attendees}
                            onChange={e => onChange("attendees", parseInt(e.target.value) || 1)}
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="3">
                    <FormGroup>
                        <RebelLabel>Currency</RebelLabel>
                        <RebelSelect
                            value={config.currency}
                            onChange={e => onChange("currency", e.target.value)}
                        >
                            {currencyOptions()}
                        </RebelSelect>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="3" md="4">
                    <FormGroup>
                        <RebelLabel>Start Date</RebelLabel>
                        <RebelDateInput
                            type="date"
                            value={config.startDate}
                            onChange={e => onChange("startDate", e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col lg="3" md="4">
                    <FormGroup>
                        <RebelLabel>End Date</RebelLabel>
                        <RebelDateInput
                            type="date"
                            value={config.endDate}
                            min={config.startDate}
                            onChange={e => onChange("endDate", e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="4">
                    <FormGroup>
                        <RebelLabel>Trip Length</RebelLabel>
                        <TripLengthDisplay>
                            {tripLength > 0 ? `${tripLength} night${tripLength !== 1 ? 's' : ''}` : '—'}
                        </TripLengthDisplay>
                    </FormGroup>
                </Col>
            </Row>
        </ConfigContainer>
    );
};

export default RebelBudgetConfig;

const ConfigContainer = styled.div`
    background-color: ${RebelColors.surfaceLight};
    border: 1px solid ${RebelColors.border};
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 0;
`;

const FormGroup = styled.div`
    margin-bottom: 1rem;
`;

const RebelDateInput = styled(RebelInput)`
    &::-webkit-calendar-picker-indicator {
        filter: invert(1);
        cursor: pointer;
    }
`;

const TripLengthDisplay = styled.div`
    background-color: ${RebelColors.gray700};
    border: 1px solid ${RebelColors.gray600};
    color: ${RebelColors.gold};
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 600;
    height: calc(1.5em + 1rem + 2px);
    display: flex;
    align-items: center;
`;
